import useGetApi from 'src/api/useGetApi';
import { UseQueryOptions } from '@tanstack/react-query';
import ApiError from 'src/api/ApiError';

export interface CoreEnumCreatedByUserDTO {
  id: string;
  name: string;
}

export interface CoreEnumOptionDTO {
  id: string;
  name: string | null;
  description: string | null;
  sortOrder: number;
  originalId: string | null;
  originalSystem: string | null;
  originalEntity: string | null;
  createdByUserId?: string | null;
  createdByUser?: CoreEnumCreatedByUserDTO | null;
}

export interface CoreEnumDTO {
  id: string;
  name: string;
  description: string;
  isSystem: boolean;
  areOptionsLocked: boolean;
  originalId: string | null;
  originalSystem: string | null;
  originalEntity: string | null;
  createdByUserId?: string | null;
  createdByUser?: CoreEnumCreatedByUserDTO | null;
  options?: CoreEnumOptionDTO[];
  optionCount: number;
}

interface PageInfo {
  hasNextPage: boolean;
  endCursor: string | null;
}

interface QueryParams {
  first?: number;
  after?: string;
  name?: string;
  includeOptions?: boolean;
  originalSystem?: string;
  originalEntity?: string;
}

export type CoreEnumsApiResponse = {
  edges: CoreEnumDTO[];
  pageInfo: PageInfo;
};

const useCoreEnums = (
  params?: QueryParams,
  options?: Omit<
    UseQueryOptions<CoreEnumsApiResponse | undefined, ApiError>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useGetApi<CoreEnumsApiResponse>({
    endpoint: 'core/core-enums',
    queryParameters: params,
    options,
  });
};

export default useCoreEnums;
